import { requestGet, requestPost } from '@/common/request';
import apis from '@/apis';

// const origin = 'http://10.170.131.196/mock/5ed46ed3393ecd00365fca1a'

export default {
  // 我的活动列表
  async fetchMyActivityList(query) {
    // return await requestGet(origin + '/acore/myactivity', query)
    return await requestGet('/activityPlan/list', query);
  },
  async fetchActivityDetail(query) {
    // return await requestGet(origin + '/acore/getActivityDetail', query)
    return apis.fetchActivityDetail(query);
  },
  async fetchCheckList(query) {
    return await requestGet('/resource/examineList', query);
  },
  async fetchCheck(query) {
    return await requestGet('/resource/firstExamineResource', query);
  },
  async fetchCheckDetail(query) {
    return await requestGet('/resource/examineDetail', query);
  },
  async fetchApplyList(query) {
    return await requestGet('/resource/applyList', query);
    // return await requestGet('http://mock.yfecj.jd.com/mock/5ed46ed3393ecd00365fca1a/acore/apply-list', query)
  },
  async deleteActivty(planCode) {
    return await requestGet('/activityPlan/delete', { planCode });
    // return await requestGet('http://mock.yfecj.jd.com/mock/5ed46ed3393ecd00365fca1a/acore/delActivity', { planCode })
  },
  // 再次同步货币化
  async syncInfoAgain(applicationId) {
    return await requestGet('/resource/synchronizeApplicationAgain', { applicationId });
  },
  // 查询用户京圈
  async getJDCrowdInfo(query) {
    return await requestGet('/resource/queryJDCrowd', query);
  },
  // 绑定用户京圈
  async bindJDCrowdInfo(query) {
    return await requestGet('/resource/bindJDCrowd', query);
  },
  // 活动管理-活动商家端上线
  async activityPlanOnline(data) {
    return await requestGet('/activityPlan/online', data);
  },
  // 活动管理-活动商家端下线
  async activityPlanOffline(data) {
    return await requestGet('/activityPlan/offline', data);
  },
  // 门槛规则白名单-保存接口
  async tagPoolSaveWhite(data) {
    return await requestGet('/tagPool/saveWhite', data);
  },
  // 门槛规则白名单-列表查询接口
  async tagPoolListWhite(data) {
    return await requestGet('/tagPool/listWhite', data);
  },
  // 门槛规则白名单-详情接口
  async tagPoolDetailWhite(data) {
    return await requestGet('/tagPool/detailWhite', data);
  },
  // 门槛规则白名单-删除
  async tagPoolDeleteWhite(data) {
    return await requestGet('/tagPool/deleteWhite', data);
  },
  // 门槛规则白名单-删除sku
  async tagPoolDeleteWhiteSku(data) {
    return await requestGet('/tagPool/deleteWhiteSku', data);
  },
  // oss文件上传接口
  async fileUpload(query) {
    return await requestPost('/oss/file/upload?module=3', query);
  },
  async tagPoolQueryDefaultQualificationId(query) {
    return await requestGet('/tagPool/queryDefaultQualificationId', query);
  },
  // 查询banner列表
  async bannerList(query) {
    return await requestGet('/banner/list', query);
  },
  // 新的查询banner列表
  async newBannerList(query) {
    return await requestGet('/generic/mac/activity/banner', query);
  },

  // 活动归档
  async activityPlanFileData(query) {
    return await requestGet('/activityPlan/fileData', query);
  },
};
